module.exports = __webpack_public_path__ + "static/media/flag.fe6a917e.png";